/**
 * ASSISTED BOOKING CONSOLE - EMBED STRATEGY
 * ==========================================
 * This wraps SendPackage.jsx with operatorMode=true to achieve
 * 100% feature parity with the customer booking flow.
 * 
 * CRITICAL: DO NOT build a separate UI - use SendPackage with operatorMode
 */

import SendPackage from "../SendPackage";

const AssistedBookingConsole = () => {
  return <SendPackage operatorMode={true} />;
};

export default AssistedBookingConsole;
